import { inject, Service } from '@angular/core'
import { Router } from '@angular/router'
import { ToastService } from '../../../shared/services/toast-service/toast.service'

/** Keeps authenticated workspace navigation retryable when required data cannot load. */
@Service()
export class WorkspaceNavigationService {
  private readonly router = inject(Router)
  private readonly toastService = inject(ToastService)

  /** Opens the workspace or its trial block, returning to the picker if loading fails.
   * @param destination The workspace entry page to load.
   */
  async open(destination: '/my-tasks' | '/trial-expired' = '/my-tasks'): Promise<void> {
    try {
      await this.router.navigate([destination])
    } catch {
      this.toastService.show(q.translations.common.failedToLoadData, 'warning')
      await this.router.navigate(['/select-workspace'])
    }
  }
}
